module.exports = __webpack_public_path__ + "static/media/Dra-Laura-Garassino.457239fb.jpg";